<script setup>
import { useAttrs, computed } from 'vue';
import SvgIcon from 'JIX/components/SvgIcon.vue';

import 'icons/button-clear.svg';

defineOptions({
    inheritAttrs: false
});

defineProps({
    label: {
        type: String,
        required: true,
    },
    iconName: {
        type: String,
        required: false,
        default: null,
    },
    iconLabel: {
        type: String,
        required: false,
        default: null,
    },
    hideOverflow: {
        type: Boolean,
        required: false,
        default: false,
    },
});

const attrs = useAttrs();

const splitAttrs = computed(() => {
    const res = { events: {}, rest: {} };
    for (const [key, value] of Object.entries(attrs)) {
        const group = key.startsWith('on') ? 'events' : 'rest';
        res[group][key] = value;
    }
    return res;
});
</script>

<template>
    <div
        v-bind="splitAttrs.rest"
        :class="['filter-button', { 'filter-button--hide-overflow': hideOverflow }]"
    >
        <div class="filter-button__content">
            <SvgIcon
                class="filter-button__icon"
                size="mini"
                :name="iconName"
                :aria-label="iconLabel"
                v-if="iconName && iconLabel"
            />
            <span class="filter-button__label">{{ label }}</span>
        </div>
        <button
            v-bind="splitAttrs.events"
            type="button"
            class="filter-button__clear"
        >
            <SvgIcon
                class="filter-button__action-icon"
                name="button-clear"
                size="micro"
                role="presentation"
            />
        </button>
    </div>
</template>
